<template>
  <div class="container">
    <div class="cc-form">
      <div class="credit-field">
        <div class="label">有効期限</div>
        <template class="field">
          <div id="card-expiry"></div>
          <span class="warning" v-if="cardExpiryError">{{cardExpiryError}}</span>
        </template>
      </div>

      <div class="credit-field">
        <div class="label">セキュリティコード</div>
        <template class="field">
          <div id="card-cvc"></div>
          <span class="warning" v-if="cardCvcError">{{cardCvcError}}</span>
        </template>
      </div>
      <div class="credit-field">
        <div class="label">クレジットカード番号</div>

        <template class="field">
          <div class="card-number-container">
            <div id="card-number"></div>
            <transition name="fade">
              <img v-if="getCardSrc(card)" :src="getCardSrc(card)" />
            </transition>
          </div>

          <span class="warning" v-if="cardNumberError">{{cardNumberError}}</span>
        </template>
      </div>

      <table v-if="Sources[0]" class="table-container">
        <thead>
          <tr>
            <th>追加日</th>
            <th>有効期限</th>
            <th>ブランド</th>
            <th>最後の4桁</th>
            <th>このカードを決済に使用</th>
            <th>削除</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-line" v-for="(source, index) in Sources" :key="index">
            <!-- <td>{{source.createdAt | moment("YYYY/MM/DD")}}</td> -->
            <td>{{source.exp_year}} / {{source.exp_month}}</td>
            <td>{{source.brand}}</td>
            <td>****-{{source.last4}}</td>
            <!-- <td>{{source.sourceId}}</td> -->
            <td>
              <el-radio
                :value="source.sourceId"
                v-model="selectedSource"
                :label="source.sourceId"
              >{{ '' }}</el-radio>
            </td>
            <td>
              <button class="button white">削除</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div style="text-align: center; margin: 30px 0;">
        <!-- <button class="button" @click="saveToken">
          <span v-if="!sourceAdding">クレジットカードを追加する</span>
          <span v-else>クレジットカードを追加しています...</span>
        </button>-->
        <button class="button" style="margin-left: 10px" @click="subscribe">サブスクリプションを開始する</button>
      </div>

      <div class="secure">
        <p>弊社では米Stripe社によるセキュアな暗号化クレジットカード決済を採用しています。</p>
        <p>クレジットカード情報を直接扱うことは御座いませんのでご安心してご利用ください。</p>
        <a href="https://stripe.com/">
          <img src="@/assets/powered_by_stripe.svg" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/main";
import { Loading } from "element-ui";

let style = {
  base: {
    // border: '1px solid #D8D8D8',
    // borderRadius: '4px',
    // color: "#888",
  },

  invalid: {
    // All of the error styles go inside of here.
  }
};
export default {
  // props: ["uid"],
  // watch: {
  //     'card.number': function(value){
  //         const regex = RegExp(/[0-9]/);
  //         if(regex.test(value[value.length-1])){
  //             var foo = value.split("-").join(""); // remove hyphens
  //             if (foo.length > 0) {
  //                 foo = foo.match(new RegExp('.{1,4}', 'g')).join("-");
  //             }
  //             this.card.number = foo
  //         } else {
  //             this.card.number = value.substr(0, value.length-1)
  //         }

  //     }
  // },
  firestore: {},
  data() {
    return {
      sourceAdding: false,
      Sources: {},
      expiry: null,
      cardType: "",
      stripe: new Stripe("pk_test_ndtRI5e73Yr1mVJnwTCTQ87T"),
      cardNumberError: null,
      cardExpiryError: null,
      cardCvcError: null,
      selectedSource: null,
      User: null,
      card: null,
      cardNumber: null,
      cardCvc: null,
      rules: {
        number: [
          //   { required: true, message: '入力必須です', trigger: 'blur' },
          //   { min: 3, max: 5, message: '3~5文字で入力してください', trigger: 'blur' },
          {
            required: true,
            pattern: /^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$/,
            message:
              "プロダクトキーは16桁の英数字で、4桁ごとにハイフンで区切られています",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    getCardSrc() {
      if (this.cardType === "unknown") {
        return null;
      } else if (this.cardType) {
        return require("@/assets/cards/" + this.cardType + ".svg");
      }
    },
    firstSubscribe() {
      this.saveToken(e);
      this.subscribe();
    },
    subscribe() {
      const cardLoading = Loading.service({
        lock: true,
        text:
          "現在クレジットカードで決済処理を行っています、ウィンドウを閉じないようにお願い致します",
        //   spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.9)",
        customClass: "loading"
      });
      let self = this;
      // db.collection("Users")
      //   .doc(this.$store.state.user.uid)
      //   .collection("Subscriptions")
      //   .add({ source: this.selectedSource })
      //   .then(() => {
      //     cardLoading.close();
      //     this.$notify({
      //       title: "Success",
      //       message: "サブスクリプションが成功しました",
      //       type: "success"
      //     });
      //   });
    },
    saveToken(e) {
      let self = this;
      self.sourceAdding = true;
      this.stripe
        .createToken(this.cardNumber)
        .then(response => {
          if (response.error) {
            console.log(response.error.message);
            return;
          }
          console.log(response);
          // db.collection("Users")
          //   .doc(this.$store.state.user.uid)
          //   .collection("Tokens")
          //   .add({ token: response.token.id, created: response.token.created })
          //   .then(() => {
          //     self.sourceAdding = false;
          //   });
        })
        .catch(err => {
          self.sourceAdding = false;
        });
    }
  },
  beforeMount() {
    let self = this;
    const elements = this.stripe.elements();

    // const uid = this.$store.state.user.uid;
    // this.$bind(
    //   "Sources",
    //   db
    //     .collection("Users")
    //     .doc(uid)
    //     .collection("Sources")
    // );
    // this.$bind("User", db.collection("Users").doc(uid));

    const elementStyles = {
      border: "1px"
    };
    const elementClasses = {};

    // カード番号
    this.cardNumber = elements.create("cardNumber");
    this.cardNumber.addEventListener("change", e => {
      self.cardType = e.brand;
      if (e.error) {
        this.cardNumberError = e.error.message;
      } else {
        this.cardNumberError = "";
      }
    });

    // カードの有効期限
    this.cardExpiry = elements.create("cardExpiry");

    this.cardExpiry.addEventListener("change", e => {
      if (e.error) {
        this.cardExpiryError = e.error.message;
      } else {
        this.cardExpiryError = "";
      }
    });
    // カードのCVC入力
    this.cardCvc = elements.create("cardCvc");

    this.cardCvc.addEventListener("change", e => {
      if (e.error) {
        this.cardCvcError = e.error.message;
      } else {
        this.cardCvcError = "";
      }
    });
  },
  mounted() {
    this.cardNumber.mount("#card-number");
    this.cardExpiry.mount("#card-expiry");
    this.cardCvc.mount("#card-cvc");
  },
  beforeDestroy() {
    this.cardNumber.unmount("#card-number");
    this.cardExpiry.unmount("#card-expiry");
    this.cardCvc.unmount("#card-cvc");
  }
};
</script>

<style  lang="scss" scoped>
.cc-form {
  margin: 0 auto;
  max-width: 600px;
}
.StripeElement {
  border: 1px solid #dcdfe6;
  font-size: 0.8rem;
  padding: 10px 15px;
  border-radius: 5px;
  color: #606266;
  user-select: none;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  &--invalid {
    border: 1px solid #f56c6c;
  }
  &--complete {
    border: 1px solid #67c23a;
  }
  &--focus {
    border: 1px solid #b1b4bb;
  }
}
.warning {
  color: #f56c6c;
  font-size: 13px;
  margin-left: 2px;
}

table {
  width: 100%;
  margin: 20px 0;
  border-radius: 5px;
  border-spacing: 0;
  border-collapse: separate;
  text-align: center;
  box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.05);

  // box-shadow: 0 50px 100px -20px rgba(50, 50, 93, 0.25),
  // 0 30px 60px -30px rgba(0, 0, 0, 0.3),
  // 0 -18px 60px -10px rgba(0, 0, 0, 0.025);

  thead {
    background: rgba(0, 0, 0, 0.01);
    th {
      padding: 0.2rem 0;
    }
  }
  tr {
    td {
      padding: 0.4rem 0;
    }
    &:first-child {
      td {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.secure {
  text-align: center !important;
  padding: 10px 0 42px 0;
  font-size: 0.9rem;
  background: #efefef;
  border-radius: 5px;
  margin: 25px 0;
  position: relative;
  p {
    margin: 0;
  }
  img {
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    user-select: none;
    &:hover {
      opacity: 0.7;
    }
  }
}

.credit-field {
  margin: 10px 0;
  .label {
    margin-bottom: 5px;
  }
}

.card-number-container {
  position: relative;
  img {
    position: absolute;
    width: 37px;
    top: 8px;
    right: 7px;
    user-select: none;
  }
}
</style>
